const { createStatusMachine } = require('./statusMachine');

const BookingStatus = Object.freeze({
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
});

const bookingStatusMachine = createStatusMachine({
  entityName: 'booking',
  states: Object.values(BookingStatus),
  initial: BookingStatus.CONFIRMED,
  transitions: {
    [BookingStatus.CONFIRMED]: [BookingStatus.CANCELLED],
    [BookingStatus.CANCELLED]: [],
  },
});

module.exports = { BookingStatus, bookingStatusMachine };
